export const arAnnouncementsTranslations = {
  announcements: {
    title: 'الإعلانات',
    subtitle: 'إدارة إعلانات مطعمك',
    create: 'إنشاء إعلان',
    createFirst: 'إنشاء أول إعلان لك',
    createTitle: 'إنشاء إعلان',
    editTitle: 'تعديل الإعلان',
    deleteTitle: 'حذف الإعلان',
    deleteMessage: 'هل أنت متأكد من حذف هذا الإعلان؟',
    noAnnouncements: 'لا توجد إعلانات بعد',
    createSuccess: 'تم إنشاء الإعلان بنجاح',
    updateSuccess: 'تم تحديث الإعلان بنجاح',
    deleteSuccess: 'تم حذف الإعلان بنجاح',
    
    // Types
    types: {
      info: 'معلومة',
      sale: 'تخفيض',
      gift: 'هدية',
      event: 'حدث',
      promo: 'عرض ترويجي'
    },
    
    // Media Types
    mediaTypes: {
      text: 'نص',
      image: 'صورة',
      video: 'فيديو'
    },
    
    // Table Headers
    table: {
      type: 'النوع',
      title: 'العنوان',
      media: 'الوسائط',
      period: 'الفترة',
      priority: 'الأولوية',
      status: 'الحالة',
      actions: 'الإجراءات'
    },
    
    // Form Fields
    form: {
      type: 'النوع',
      mediaType: 'نوع الوسائط',
      mediaUrl: 'رابط الوسائط',
      image: 'الصورة',
      title: 'العنوان',
      titlePlaceholder: 'أدخل عنوان الإعلان',
      description: 'الوصف',
      descriptionPlaceholder: 'أدخل الوصف',
      discount: 'الخصم',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      priority: 'الأولوية',
      isActive: 'نشط',
      uploading: 'جاري الرفع...',
      clickToUpload: 'اضغط للرفع',
      orDragDrop: 'أو اسحب وأفلت'
    },
    
    // Errors
    errors: {
      titleRequired: 'العنوان مطلوب',
      startDateRequired: 'تاريخ البداية مطلوب',
      endDateRequired: 'تاريخ النهاية مطلوب',
      endDateAfterStart: 'يجب أن يكون تاريخ النهاية بعد تاريخ البداية',
      mediaUrlRequired: 'رابط الوسائط مطلوب لنوع الصورة',
      invalidImageType: 'يسمح فقط بصور JPEG و PNG و WebP',
      imageTooLarge: 'يجب أن يكون حجم الصورة أقل من 5 ميجابايت',
      uploadFailed: 'فشل في رفع الصورة'
    }
  }
};
